/**
 * src/api/competidoresRevision.js
 * ¿Sigue siendo correcta la lista de competidores de cada tenant?
 *
 * Nace de una prueba de usuario (04-09-2026): los competidores reales del cliente
 * no estaban en su lista, y los que estaban compartían muy pocos productos con
 * él. La causa era la misma para las dos mitades — la lista se sembraba UNA vez,
 * con un criterio de pura presencia, y no se revisaba nunca.
 *
 * El endpoint solo DIAGNOSTICA. Aplicar los cambios sigue siendo del admin, en la
 * ficha del cliente, que es donde ya se editan los competidores.
 */
import api from './client'

// Una fila por tenant activo. `solo_con_cambios` deja la lista de trabajo real.
export const revisarCompetidores = ({ soloConCambios = false, clienteId = null } = {}) =>
  api.get('/admin/competidores/revision', {
    params: {
      solo_con_cambios: soloConCambios,
      ...(clienteId ? { cliente_id: clienteId } : {}),
    },
  }).then(r => r.data)
